// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1UShG","footer":"ReportModalFilter_footer__7OLr7"};